export const STYLES = {
  WRAPPER:
    'flex items-center min-h-[58px] w-[100%] bg-[#FFF] border-b-[1px] border-bw03 px-[34px] py-[17px] my-0 mx-auto',
  MAIN_WRAPPER:
    'flex items-center justify-between w-full bg-bg-bw00 border-b-[1px] border-bw03 px-[34px] py-[17px] relative',
  DIVIDER: 'mr-[10px]',
  LINK: 'font-metricR text-bw06 text-[12px] mx-[4px]',
  LINK_ACTIVE: 'font-metricR text-bw08 text-[12px] mx-[4px]',
  ACTIVE_LINK_TITLE: 'font-metricR text-bw08 text-[20px]',
  MAIN_TITLE: 'font-metricR text-[16px] text-bw08 absolute top-[50%] translate-y-[-50%] left-[50%] translate-x-[-50%]',
};

export interface ListItem {
  name: string;
  path?: string;
}
